import { LoginProjectData } from '../../../api/dasboard/types';

export type StatisticCardState = {
  currProject: LoginProjectData | null;
  fetching: boolean;
  error: boolean;
};

export type SetupStepsType = {
  nextStep: string | null;
  stepNumber: number | null;
  fetching: boolean;
};

export enum ActionType {
  stopFetching = 'stopFetching',
  getDataStart = 'getUsersStart',
  getDataSuccess = 'getUsersSuccess',
  getDataFail = 'getUsersFail'
}

export type Action = {
  type: ActionType;
  payload?: unknown;
};
